const mapping = (index) => `http://localhost:3333/#paginator-render?page=${index}`;
export const paginatorRenderNumericModel = {
    totalPages: 30,
    urlMapping: mapping
};
export const paginatorRenderNumericModelWithoutUrlMapping = { totalPages: 20 };
export const paginatorRenderNumericModelWithoutTotalPages = { urlMapping: mapping };
export const paginatorRenderHyperlinkModel = [
    `http://localhost:3333/#paginator-render?page=1`,
    `http://localhost:3333/#paginator-render?page=2`,
    `http://localhost:3333/#paginator-render?page=3`,
    `http://localhost:3333/#paginator-render?page=4`,
    `http://localhost:3333/#paginator-render?page=5`,
    `http://localhost:3333/#paginator-render?page=6`,
    `http://localhost:3333/#paginator-render?page=7`,
    `http://localhost:3333/#paginator-render?page=8`,
    `http://localhost:3333/#paginator-render?page=9`,
    `http://localhost:3333/#paginator-render?page=10`
];
export const itemsPerPageOptionsModel = [
    { value: "10", caption: "10" },
    { value: "20", caption: "20" },
    { value: "30", caption: "30" }
];
